import { Box } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { ContentBreadcrumbs, ContentBreadcrumbsProps } from './ContentBreadcrumbs';
// import { ContentButton } from './ContentButton';
import { ContentTitle, ContentTitleProps } from './ContentTitle';

export type ContentLayoutProps = {
  width?: string;
  height?: string;
  padding?: string;
  background?: string;
  titleProps?: ContentTitleProps;
  breadcrumbsProps?: ContentBreadcrumbsProps;
  children?: React.ReactNode;
  customeButtonProps?: React.ReactNode;
};

export const ContentLayout = (props: ContentLayoutProps) => {
  const { width, height, padding, background, titleProps, breadcrumbsProps, children, customeButtonProps } = props;

  return (
    <Box
      id="content_layout"
      sx={{
        width: width
          ? `min(${width}, calc(100vw - var(--side-menu-width, 0px)))`
          : 'calc(100vw - var(--side-menu-width, 0px))',
        maxWidth: '100%',
        height: height,
        background: background,
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        minHeight: '100vh',
        padding: padding ? padding : '25px 30px',
      }}
    >
      {breadcrumbsProps && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            height: '50px',
            marginLeft: '1px',
          }}
        >
          <ContentBreadcrumbs breadcrumbsItems={breadcrumbsProps.breadcrumbsItems} />
        </Box>
      )}
      {titleProps && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            marginLeft: '20px',
          }}
        >
          <ContentTitle title={titleProps.title} />
        </Box>
      )}
      {customeButtonProps && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          {customeButtonProps}
        </Box>
      )}
      <Box component="main">
        <LocalizationProvider dateAdapter={AdapterDayjs}>{children}</LocalizationProvider>
      </Box>
    </Box>
  );
};
ContentLayout.defaultProps = {
  background: '#FFFFFF',
  children: null,
};
